import Icon from '../shared/components/icon/icon';
import './detail-studio.scss';


import { useLocation } from 'react-router-dom';

//material
import { Button, CircularProgress, TextField } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';

//shared
import { USER_INFO } from '../shared/graphql/login';

import Cropper from 'react-easy-crop'

import Modal from '../shared/components/modal-alert/modal-alert';
import { useMutation, useQuery } from '@apollo/client';
import { GET_STUDIO_BY_BRANCH, UPDATE_STUDIO } from '../shared/graphql/branch';
import { useParams } from 'react-router-dom';
import { MESSAGE_DEFAULT } from '../class-branch/constants/messages';
import Message from '../shared/components/message/message';

const DetailStudio = () => {

    const { id }: any = useParams();
    let [valueDescription, setValueDescription] = useState(String);

    const { data: userInfoData, error: userInfoError } = useQuery(USER_INFO);
    if (userInfoError) console.log(`Submission error! ${userInfoError.message}`);

    const { data: studioData } = useQuery(GET_STUDIO_BY_BRANCH, {
        variables: { id: parseInt(id) }
    });

    const studioId = studioData?.studioByBranch?.id

    const [UpdateStudio, { loading: loadingUpdateStudio }] = useMutation(UPDATE_STUDIO, {
        variables: {
            studioId: parseInt(studioId),
            imageBase: '',
            description: '',
        },
        refetchQueries: [GET_STUDIO_BY_BRANCH]
    });

    let [imageBranch, setImageBranch] = useState(String);

    const location: any = useLocation();
    const [estatusModal, changeStateModal] = useState(false);

    const [editedImage, setEditedImage] = useState<any>(null);
    //AQUI
    // const [editedImageFile, setEditedImageFile] = useState<any>(null);

    let isAdmin = false;
    if (userInfoData && userInfoData.user.manager) {
        if (userInfoData.user.manager.studio_id && userInfoData.user.manager.branch_id)
            isAdmin = true;
    }

    useEffect(() => {
        const elementToStyle: any = document.querySelector('.box-menu .MuiButtonGroup-root');

        if (location.pathname === '/detail-studio/' + id && elementToStyle) {
            elementToStyle.style.display = 'none';
        } else if (elementToStyle) {
            elementToStyle.style.display = 'inline-flex';
        }

        if (studioData?.studioByBranch?.imageUrl) {
            setImageBranch(studioData?.studioByBranch?.imageUrl);
        }

        return () => {
            elementToStyle.style.display = 'inline-flex';
        };
    }, [id, location.pathname, studioData]);


    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    const handleImageChange = (event: any) => {
        const file = event.target.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onload = (e: any) => {
                setSelectedImage(e.target.result);
            };

            reader.readAsDataURL(file);

            changeStateModal(!estatusModal)
        }
    };

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)

    const onCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
        const canvas = document.createElement('canvas');
        const img: any = new Image();
        img.src = selectedImage;
        canvas.width = croppedAreaPixels.width;
        canvas.height = croppedAreaPixels.height;
        const ctx: any = canvas.getContext('2d');

        ctx.drawImage(
            img,
            croppedAreaPixels.x,
            croppedAreaPixels.y,
            croppedAreaPixels.width,
            croppedAreaPixels.height,
            0,
            0,
            croppedAreaPixels.width,
            croppedAreaPixels.height
        );

        // Convierte el lienzo en un archivo Blob
        /* canvas.toBlob((blob: any) => {
            const editedImageURL: any = URL.createObjectURL(blob);
            setEditedImage(editedImageURL);
            setEditedImageFile(blob);
        }, "image/jpeg");
         */


        // Convierte el lienzo en una base64
        const base64Image = canvas.toDataURL('image/jpeg');
        setEditedImage(base64Image)

    }, [selectedImage]);


    const handleModalClose = () => {
        (document.getElementById('button-file') as HTMLInputElement).value = '';
        changeStateModal(false);
    };

    const handleSaveEditedImage = async () => {

        await UpdateStudio({
            variables: {
                studioId: parseInt(studioId),
                imageBase: editedImage,
                description: '',
            },
        }).then((data: any) => {
            if (data?.data?.updateStudio?.success) {
                setImageBranch(editedImage);
                changeStateModal(!estatusModal)
            }
        }
        ).catch((error) => {
            console.error(error)
        });

        setEditedImage(null);
        // setEditedImageFile(null);

    };

    const [isActiveEditDescription, setIsActiveEditDescription] = useState(false)

    const activeDescriptionEdit = () => {
        if (studioData?.studioByBranch?.description) {
            setValueDescription(studioData?.studioByBranch?.description);
        }

        setIsActiveEditDescription(true);
    }

    let message = MESSAGE_DEFAULT;
    message.open = useRef<any>(null);

    const saveDescription = async () => {
        await UpdateStudio({
            variables: {
                studioId: parseInt(studioId),
                imageBase: '',
                description: valueDescription,
            },
        }).then((data: any) => {

            setIsActiveEditDescription(false);

            if (!data.data.updateStudio)
                return;

            message.textMessage = data.data.updateStudio.message;
            message.style = data.data.updateStudio.success ? 'success' : 'danger';
            setTimeout(() => {
                message.open.current.show();
            }, 500);
        }
        ).catch((error) => {
            console.error(error)
        });

    }

    return (
        <div className='container-detail-studio'>
            <div className='w-100'>
                <h1 className='img-studio'>

                    <img src={imageBranch ? imageBranch : 'https://www.fitpal.co/assets/img/load_img.png'} alt="Tu sede" />

                    {
                        isAdmin && (<Button className='btn-change-img' component='label'>
                            <Icon name='change' width='15' height='15' color='#747474' />
                            <input type='file' hidden accept="image/*" onChange={handleImageChange} id='button-file' />
                        </Button>
                        )
                    }
                </h1>
                <h1 className='title'>{studioData?.studioByBranch?.tradeName}</h1>

                {
                    isActiveEditDescription ?
                        <TextField className='textarea-description'
                            multiline color='secondary'
                            sx={{ borderRadius: '6px', width: '100%', height: 'auto' }}
                            value={valueDescription}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                setValueDescription(event.target.value);
                            }}
                        />
                        :
                        <p className='description'>{studioData?.studioByBranch?.description}</p>
                }

                {
                    isAdmin && (

                        <div className='edit-container'>
                            {!isActiveEditDescription ?
                                <Button className='edit-description' onClick={() => { activeDescriptionEdit() }}>
                                    <Icon name='edit' width='20' height='20' color='#747474' />
                                    <span className='ml-1'>Editar descripción</span>
                                </Button>
                                :
                                <Button className='edit-description' onClick={() => { saveDescription() }}>
                                    Guardar
                                </Button>
                            }
                        </div>
                    )
                }

                {
                    !studioData?.studioByBranch?.description && (
                        <div className='edit-container'>
                            Sin información
                        </div>
                    )
                }

            </div>
            <Modal estatus={estatusModal}
                changeStatus={changeStateModal}
                title='Editar tu imagen'
                buttonCancel={true}
                showHeader={true}
                onClose={handleModalClose}
                classNameModal='modal-cropper-img'>
                <div className='container p-2'>

                    <div className='crop-container'>
                        {selectedImage && (
                            <Cropper
                                image={selectedImage}
                                crop={crop}
                                zoom={zoom}
                                aspect={4 / 4}
                                onCropChange={setCrop}
                                onCropComplete={onCropComplete}
                                onZoomChange={setZoom}
                            />
                        )}
                    </div>
                    <div className="controls">
                        <div className='range'>
                            <input
                                type='range'
                                value={zoom}
                                min={1}
                                max={3}
                                step={0.1}
                                aria-labelledby='Zoom'
                                onChange={(e: any) => {
                                    setZoom(e.target.value)
                                }}
                                className='zoom-range'
                            />
                        </div>
                        <div className='save-edited-img'>
                            {!loadingUpdateStudio && (
                                <Button onClick={handleSaveEditedImage}>Guardar</Button>
                            )
                            }
                            {loadingUpdateStudio && (
                                <p style={{ textAlign: 'center' }}>
                                    <CircularProgress size={25} />
                                </p>
                            )
                            }
                        </div>
                    </div>
                </div>
            </Modal>

            <Message data={message} ref={message.open}></Message>
        </div>
    );
}

export default DetailStudio;